/**
 * Decorative hover circle that follows the mouse over .card a elements.
 * Desktop only. Uses direct top/left positioning with CSS transitions for trailing.
 * A MutationObserver handles dynamically loaded cards (AJAX infinite scroll).
 */
(function () {
    if (window.matchMedia('(hover: none)').matches) return;

    const cursor = document.createElement('div');
    cursor.className = 'custom-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cursor);

    document.addEventListener('mousemove', function (e) {
        cursor.style.top = e.clientY + 'px';
        cursor.style.left = e.clientX + 'px';
    });

    function show() {
        cursor.classList.add('custom-cursor--visible');
    }

    function hide() {
        cursor.classList.remove('custom-cursor--visible');
    }

    const bound = new WeakSet();

    function bind(link) {
        if (bound.has(link)) return;
        bound.add(link);
        link.addEventListener('mouseenter', show);
        link.addEventListener('mouseleave', hide);
    }

    document.querySelectorAll('.card a').forEach(bind);

    new MutationObserver(function () {
        document.querySelectorAll('.card a').forEach(bind);
    }).observe(document.body, { childList: true, subtree: true });
})();
